// extracted by mini-css-extract-plugin
export default {"V2FormTreeSelect":"V2FormTreeSelect--urYqa"};